// 标签页切换功能
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.cart-drawer__tab');
  const contents = document.querySelectorAll('.cart-drawer__tab-content');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.dataset.tab;
      
      // 移除所有活动状态
      tabs.forEach(t => t.classList.remove('cart-drawer__tab--active'));
      contents.forEach(c => c.classList.remove('cart-drawer__tab-content--active'));
      
      // 添加当前活动状态
      this.classList.add('cart-drawer__tab--active');
      document.querySelector(`[data-content="${targetTab}"]`).classList.add('cart-drawer__tab-content--active');

      // 如果是最近浏览标签页，刷新内容
      if (targetTab === 'recently-viewed' && window.refreshRecentlyViewed) {
        window.refreshRecentlyViewed();
      }
    });
  });

  // Order Note 抽屉功能
  const orderNoteTrigger = document.getElementById('order-note-trigger');
  const orderNoteDrawer = document.getElementById('order-note-drawer');
  const orderNoteClose = document.getElementById('order-note-close');
  const orderNoteSave = document.getElementById('order-note-save');
  const orderNoteTextarea = document.getElementById('order-note-textarea');

  // 打开 Order Note 抽屉
  if (orderNoteTrigger) {
    orderNoteTrigger.addEventListener('click', function() {
      orderNoteDrawer.classList.add('active');
      // 聚焦到文本框
      setTimeout(() => {
        orderNoteTextarea.focus();
      }, 300);
    });
  }

  // 关闭 Order Note 抽屉
  if (orderNoteClose) {
    orderNoteClose.addEventListener('click', function() {
      orderNoteDrawer.classList.remove('active');
    });
  }

  // 保存 Order Note
  if (orderNoteSave) {
    orderNoteSave.addEventListener('click', function() {
      const noteText = orderNoteTextarea.value.trim();
      
      // 这里可以添加保存到购物车的逻辑
      // 例如通过 AJAX 请求保存到 Shopify 购物车属性
      console.log('Order note saved:', noteText);
      
      // 关闭抽屉
      orderNoteDrawer.classList.remove('active');
      
      // 可以显示保存成功的提示
      // showNotification('Order note saved successfully!');
    });
  }

  // 点击抽屉外部关闭
  if (orderNoteDrawer) {
    orderNoteDrawer.addEventListener('click', function(e) {
      if (e.target === orderNoteDrawer) {
        orderNoteDrawer.classList.remove('active');
      }
    });
  }

  // ESC 键关闭抽屉
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && orderNoteDrawer.classList.contains('active')) {
      orderNoteDrawer.classList.remove('active');
    }
  });
});